import { createSlice } from "@reduxjs/toolkit";

const initialState={
    reportListFooter:null
}

const setReportListFooter=(state, action)=>{
    state.reportListFooter=action.payload
}
const ReportListSlice=createSlice({
    name:"reportList",
    initialState,
    reducers:{
        setReportListFooter   
    }
})

export const{
    setReportListFooter:setReportListFooterR
}=ReportListSlice.actions;

export default ReportListSlice.reducer